import { cn } from '@/utilities/ui'

export type OpsampButtonVariant = 'default' | 'primary' | 'secondary' | 'outline' | 'ghost'
export type OpsampButtonTone = 'dark' | 'light'

export const opsampButtonBase =
  'inline-flex min-h-[52px] items-center justify-center rounded-[8px] px-[22px] text-center font-black leading-[1.2] tracking-normal no-underline transition duration-300'

export const opsampPrimaryButton =
  'border border-[#d6a943] bg-[linear-gradient(135deg,#f0d078,#d6a943)] text-[#0e1c2a] shadow-[0_14px_30px_rgba(214,169,67,0.2)] hover:brightness-105 hover:text-[#0e1c2a]'

export const opsampSecondaryDarkButton =
  'border border-[#f7f3ea]/45 bg-[#f7f3ea]/[0.04] text-[#f7f3ea] hover:bg-[#f7f3ea]/10 hover:text-[#f7f3ea]'

export const opsampSecondaryLightButton =
  'border border-[#0e1c2a]/20 bg-white/40 text-[#17202a] hover:bg-white/60 hover:text-[#17202a]'

export const opsampGhostButton =
  'border border-transparent bg-transparent text-[#d6a943] hover:bg-[#d6a943]/10 hover:text-[#0e1c2a]'

export const opsampButtonClasses = (
  variant: OpsampButtonVariant = 'default',
  tone: OpsampButtonTone = 'dark',
  className?: string,
) => {
  const visual =
    variant === 'default' || variant === 'primary'
      ? opsampPrimaryButton
      : variant === 'ghost'
        ? opsampGhostButton
        : tone === 'light'
          ? opsampSecondaryLightButton
          : opsampSecondaryDarkButton

  return cn(opsampButtonBase, visual, className)
}
